function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg143Niue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#F0F0F0"
    },
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 104.001,152.001 104.001,256.001 152.001,256.001 152.001,152.001 256,152.001   256,104.001 152.001,104.001 152.001,0.001 104.001,0.001 104.001,104.001 0,104.001 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "203.46,166.958 256,219.498 256,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "232.282,256.001 166.957,190.67 166.957,256.001  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "40.151,166.958 0,207.108 0,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.041,178.281 89.041,255.999 11.33,255.999  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.96 0,230.822 0,256.001 0,256.001 89.041,166.96 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "52.54,89.045 0,36.504 0,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "23.718,0.001 89.043,65.332 89.043,0.001  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "215.849,89.045 256,48.894 256,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.959,77.722 166.959,0.002 244.67,0.002  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.042 256,25.18 256,0.001 256,0.001 166.959,89.042 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2E52B2"
    },
    cx: 128,
    cy: 128,
    r: 31.499
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "128,105.726 133.528,122.742 151.422,122.742 136.947,133.259 142.475,150.276 128,139.759    113.524,150.276 119.053,133.259 104.578,122.742 122.47,122.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "128,181.521 131.291,191.653 141.946,191.653 133.327,197.915 136.618,208.047 128,201.785    119.381,208.047 122.673,197.915 114.054,191.653 124.708,191.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "128,47.955 131.291,58.088 141.946,58.088 133.327,64.349 136.618,74.482 128,68.22    119.381,74.482 122.673,64.349 114.054,58.088 124.708,58.088  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "209.545,114.738 212.836,124.87 223.491,124.87 214.872,131.132 218.164,141.264    209.545,135.002 200.925,141.264 204.218,131.132 195.598,124.87 206.253,124.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "46.455,114.738 49.746,124.87 60.402,124.87 51.782,131.132 55.073,141.264 46.455,135.002    37.836,141.264 41.128,131.132 32.509,124.87 43.163,124.87  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg143Niue);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };